import { render, staticRenderFns } from "./NoticeHome.vue?vue&type=template&id=4c904b47&scoped=true"
import script from "./NoticeHome.vue?vue&type=script&lang=js"
export * from "./NoticeHome.vue?vue&type=script&lang=js"
import style0 from "./NoticeHome.vue?vue&type=style&index=0&id=4c904b47&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c904b47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c904b47')) {
      api.createRecord('4c904b47', component.options)
    } else {
      api.reload('4c904b47', component.options)
    }
    module.hot.accept("./NoticeHome.vue?vue&type=template&id=4c904b47&scoped=true", function () {
      api.rerender('4c904b47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/NoticeHome.vue"
export default component.exports